import Swiper from 'swiper/bundle';

(function ($) {
    let swiper = new Swiper(".section-slider-images-text .slider-images-text", {
        slidesPerView: 'auto',
        spaceBetween: 24,
        navigation: {
            nextEl: ".section-slider-images-text .swiper-button-next",
            prevEl: ".section-slider-images-text .swiper-button-prev",
        },
        scrollbar: {
            el: '.section-slider-images-text .swiper-scrollbar',
            draggable: true,
        }
    });
})(jQuery);